import React from 'react';
import {
  useFindOrCreateReservationPartyMutation as useFindOrCreateReservationPartyEndpointMutation,
  useGetReservationPartiesLookupQuery as useGetReservationPartiesLookupEndpointQuery,
} from './extendedReservationsApi';
import {
  mapReservationPartyDtoToLookup,
  type ReservationPartyLookup,
} from './reservationPartiesLookupMapper';
import type {
  ReservationPartyFindOrCreateRequest,
  ReservationPartyLookupDto,
  ReservationPartyLookupRequest,
} from '../Types/reservationTypes';

export const useGetReservationPartiesLookupQuery = (): {
  parties: ReservationPartyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetReservationPartiesLookupEndpointQuery();

  const parties = React.useMemo(
    () =>
      (data ?? [])
        .map((party) => mapReservationPartyDtoToLookup(party))
        .filter((item): item is ReservationPartyLookup => item !== undefined)
        .sort((a, b) => a.label.localeCompare(b.label, 'pl')),
    [data]
  );

  return { parties, isLoading };
};

export const useSearchableReservationPartiesLookupQuery = (
  request?: ReservationPartyLookupRequest,
  skip = false
): {
  parties: ReservationPartyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetReservationPartiesLookupEndpointQuery(request, { skip });

  const parties = React.useMemo(
    () =>
      (data ?? [])
        .map((party) => mapReservationPartyDtoToLookup(party))
        .filter((item): item is ReservationPartyLookup => item !== undefined)
        .sort((a, b) => a.label.localeCompare(b.label, 'pl')),
    [data]
  );

  return { parties, isLoading };
};

export const useFindOrCreateReservationPartyMutation = (): [
  (payload: ReservationPartyFindOrCreateRequest) => Promise<ReservationPartyLookupDto>,
] => {
  const [mutate] = useFindOrCreateReservationPartyEndpointMutation();

  return [React.useCallback((payload: ReservationPartyFindOrCreateRequest) => mutate(payload).unwrap(), [mutate])];
};
